var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrugsIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000072975551440698986980000003940511793790966150_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D61;}\n\t.st1{fill:#801950;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.4,105.6C385,84.2,357,73.5,329,73.5s-56.1,10.7-77.5,32.1L190.1,167l-16,16l-68.5,68.5 c-42.8,42.8-42.8,112.1,0,154.9c21.4,21.4,49.4,32.1,77.5,32.1s56.1-10.7,77.5-32.1l68.5-68.5l16-16l61.4-61.4 C449.2,217.7,449.2,148.4,406.4,105.6L406.4,105.6z M289.2,341.5l-46.8,46.8c-32.7,32.7-86,32.7-118.7,0 c-32.7-32.7-32.7-86,0-118.7l46.8-46.8c6.9-6.9,18.2-6.9,25.1,0l93.7,93.7C296.2,323.3,296.2,334.6,289.2,341.5L289.2,341.5z  M369.6,124.7c-2.8,8.1-11.7,12.4-19.8,9.6c-6.2-2.2-12.5-3.1-18.8-2.8c-15.1,0.8-25.9,8.8-31,13.6l-35.2,35.2L246.1,199 c-3,3-7,4.6-11,4.6s-8-1.5-11-4.6c-6.1-6.1-6.1-15.9,0-22l17.4-17.4l37-37c8.2-7.7,25.7-20.9,51-22.2c10.3-0.5,20.6,1,30.6,4.5 C368.1,107.8,372.4,116.6,369.6,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.6,124.7c-2.8,8.1-11.7,12.4-19.8,9.6c-6.2-2.2-12.5-3.1-18.8-2.8c-15.1,0.8-25.9,8.8-31,13.6l-35.2,35.2 L246.1,199c-3,3-7,4.6-11,4.6s-8-1.5-11-4.6c-6.1-6.1-6.1-15.9,0-22l17.4-17.4l37-37c8.2-7.7,25.7-20.9,51-22.2 c10.3-0.5,20.6,1,30.6,4.5C368.1,107.8,372.4,116.6,369.6,124.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.3,167c-3-3-6.3-5.5-9.9-7.4L224.1,177c-6.1,6.1-6.1,15.9,0,22c3,3,7,4.6,11,4.6s8-1.5,11-4.6l18.6-18.6 L251.3,167L251.3,167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.6,124.7c-2.8,8.1-11.7,12.4-19.8,9.6c-6.2-2.2-12.5-3.1-18.8-2.8c-15.1,0.8-25.9,8.8-31,13.6l-35.2,35.2 L246.1,199c-3,3-7,4.6-11,4.6s-8-1.5-11-4.6c-6.1-6.1-6.1-15.9,0-22l17.4-17.4l37-37c8.2-7.7,25.7-20.9,51-22.2 c10.3-0.5,20.6,1,30.6,4.5C368.1,107.8,372.4,116.6,369.6,124.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugsIconBlue);
export default __webpack_public_path__ + "static/media/Drugs_icon_blue.04b7afb27a6fc3aab1fab9ce819a0e52.svg";
export { ForwardRef as ReactComponent };